export function getCurrentUser(): { id?: string; role?: string; company_id?: string } | null {
  if (
    typeof localStorage === 'undefined' ||
    typeof sessionStorage === 'undefined' ||
    typeof localStorage.getItem !== 'function' ||
    typeof sessionStorage.getItem !== 'function'
  ) {
    return null
  }

  const rawUser = localStorage.getItem('user') || sessionStorage.getItem('user')
  if (!rawUser) {
    return null
  }

  try {
    return JSON.parse(rawUser) as { id?: string; role?: string; company_id?: string } | null
  } catch {
    return null
  }
}
